import { Observable } from "rxjs/Observable";
import { Injectable } from "@angular/core";
import { AngularFireDatabase } from "angularfire2/database";
import "rxjs/add/observable/zip";

@Injectable()
export class BillService {
    constructor(private db: AngularFireDatabase) { }

    getOutstandingBills(communityId): any {
        return this.db.object(`/current_subscriptions/${communityId}`).valueChanges().map(currentSubscritions => {
            const outstandingBills = [];

            const userIds = currentSubscritions ? Object.keys(currentSubscritions) : [];

            this.db.object(`/subscriptions/${communityId}`).valueChanges().subscribe(subscriptions => {
                userIds.forEach(userId => {
                    const residentSubscriptionKeys = [];
                    const residentCurrentSubscriptions = Object.values(currentSubscritions[userId]);

                    for (const item of residentCurrentSubscriptions) {
                        residentSubscriptionKeys.push(item["subscription"]);
                    }

                    const residentSubscriptionObj = subscriptions[userId];

                    residentSubscriptionKeys.forEach(subscriptionId => {
                        const subscription = residentSubscriptionObj[subscriptionId];

                        if (!(subscription.balance > 0 && subscription.isActive && Date.now() > subscription.expiryDate)) {
                            return Observable.of([]);
                        }

                        subscription.resident = userId;
                        const $serviceName = this.db.object(`/billtypes/${subscription.billTypeId}/name`).valueChanges();
                        const $resident = this.db.object(`/profile/${subscription.resident}`).valueChanges();

                        return Observable.zip($serviceName, $resident, (serviceName, profile: any) => {
                            if (profile) {
                                subscription.residentName = `${profile.firstName} ${profile.lastName}`;
                                subscription.serviceName = serviceName;
                                outstandingBills.push(subscription);

                                return outstandingBills;
                            }
                        }).subscribe(result => result);
                    });
                });
            });

            return outstandingBills;
        });
    }

    createBillReminder(messageObj): any {
        return this.db.list("/outstanding_bills")
            .push(messageObj).then(result => {
                messageObj["id"] = result.key;
                this.db.list("/outstanding_bills").update(result.key, messageObj);
            });
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/bill/bill.service.ts